module.exports = __webpack_public_path__ + "img/caret-left.eaf311b7.svg";